import { render, staticRenderFns } from "./PersonalPreferencesForm.vue?vue&type=template&id=664b7a8c&scoped=true"
import script from "./PersonalPreferencesForm.vue?vue&type=script&lang=ts"
export * from "./PersonalPreferencesForm.vue?vue&type=script&lang=ts"
import style0 from "./PersonalPreferencesForm.vue?vue&type=style&index=0&id=664b7a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664b7a8c",
  null
  
)

export default component.exports